import * as React from 'react';

// Utils
import {
  comp,
  getNameFromPointSpreadValue,
  getPointSpreadValueFromName,
  isStrictlyUSHandicap } from
'../util/utils';

// Interfaces
import type IBet from '../interfaces/IBet';

import styles from '../style/bet.module.css';
import Icon from '~/components/icon';

interface IProps {
  bet: IBet;
  disabled: boolean;
  removeBet: (betId: number, disabled?: boolean) => void;
}

function Bet({ bet, disabled, removeBet }: IProps): JSX.Element {
  const [betName, setBetName] = React.useState(bet.name);
  const [spread, setSpread] = React.useState<string | number>('');

  React.useEffect(() => {
    if (isStrictlyUSHandicap(bet)) {
      setBetName(getNameFromPointSpreadValue(bet.name));
      setSpread(getPointSpreadValueFromName(bet.name));
    }
  }, [bet]);

  return (
    <div className={comp(styles.betWrapper, disabled ? styles.disabled : '')}>
			<div>
				<span className={styles.name}>{betName}</span>
				{spread && <span className={styles.spreadValue}>{spread}</span>}
				<div className={styles.subeventName}>{bet.subeventName}</div>
				<div className={styles.marketName}>{bet.marketName}</div>
			</div>
			<span
        className={styles.closeBet}
        data-testid="betslip-close"
        onClick={() => removeBet(bet.betId, disabled)}>

				<Icon icon="Close" height={32} width={32} />
			</span>
		</div>);

}

export default Bet;